export default "__VITE_ASSET__DeWAEm7F__"